import { ApiResponse } from 'apisauce';
import { ErrorInfo } from '../../../shared/interfaces/error-info.interface';
import { ResponseModel } from '../../../shared/interfaces/response-model.interface';
import AreaMapper from '../../../shared/mappers/area.mapper';
import { AreaModel } from '../../../shared/models/area.model';
import api from '../../../shared/services/utils/api/api.service';
import errorHelper from '../../../shared/services/utils/api/error-helper.service';
import { AreaUiModel } from '../../../shared/ui-models/area.ui-model';
import { getModuleName } from './dashboard.service';
import { ReservationUpdates } from '../../../shared/ui-models/reservation-updates.ui-model';
import { OccupancyResponseModel } from '../../../shared/ui-models/occupancy.ui-model';
import { BlockDatesModel } from '../../../shared/models/block-dates.model';

export function addNewArea(areaData: AreaUiModel): Promise<AreaUiModel | ErrorInfo> {
  const mappedArea = AreaMapper.mapToModel(areaData);
  return api
    .createArea(mappedArea)
    .then((response: ApiResponse<ResponseModel<AreaModel>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return AreaMapper.mapToUI(data.data);
        } else {
          return errorHelper(0, '', getModuleName(), (api.createArea as any).displayName);
        }
      } else {
        return errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          getModuleName(),
          (api.createArea as any).displayName
        );
      }
    });
}

export function updateArea(
  areaId: string,
  areaData: AreaUiModel
): Promise<AreaUiModel | ErrorInfo> {
  const mappedArea = AreaMapper.mapToModel(areaData);
  return api
    .updateArea(areaId, mappedArea)
    .then((response: ApiResponse<ResponseModel<AreaModel>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return AreaMapper.mapToUI(data.data);
        } else {
          return errorHelper(0, '', getModuleName(), (api.updateArea as any).displayName);
        }
      } else {
        return errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          getModuleName(),
          (api.updateArea as any).displayName
        );
      }
    });
}

export function deleteArea(areaId: string): Promise<{} | ErrorInfo> {
  return api.deleteArea(areaId).then((response: ApiResponse<ResponseModel<{}>, ErrorInfo>) => {
    if (response.ok) {
      const { data } = response;
      if (data && data.data) {
        return {};
      } else {
        return errorHelper(0, '', getModuleName(), (api.deleteArea as any).displayName);
      }
    } else {
      return errorHelper(
        Number(response.status),
        response.data && response.data.errorCode
          ? String(response.data.errorCode || '')
          : response.problem,
        getModuleName(),
        (api.deleteArea as any).displayName
      );
    }
  });
}
export function getAllMonthlyRevenu(
  monthsCount: number
): Promise<{ month: string; revenue: number }[] | ErrorInfo> {
  return api
    .getMonthlyRevenue(monthsCount)
    .then((response: ApiResponse<ResponseModel<{}>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return data.data as { month: string; revenue: number }[];
        } else {
          return errorHelper(0, '', getModuleName(), (api.deleteArea as any).displayName);
        }
      } else {
        return errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          getModuleName(),
          (api.deleteArea as any).displayName
        );
      }
    });
}
export function getAllReservationsUpdates(): Promise<ReservationUpdates | ErrorInfo> {
  return api
    .getReservationsUpdates()
    .then((response: ApiResponse<ResponseModel<ReservationUpdates>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return data.data;
        } else {
          return errorHelper(0, '', getModuleName(), (api.deleteArea as any).displayName);
        }
      } else {
        return errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          getModuleName(),
          (api.deleteArea as any).displayName
        );
      }
    });
}
export function getAllOccupancy(): Promise<OccupancyResponseModel[] | ErrorInfo> {
  return api
    .getOccupancy()
    .then((response: ApiResponse<ResponseModel<OccupancyResponseModel[]>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return data.data;
        } else {
          return errorHelper(0, '', getModuleName(), (api.deleteArea as any).displayName);
        }
      } else {
        return errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          getModuleName(),
          (api.deleteArea as any).displayName
        );
      }
    });
}

export function getAllBlockingDates(query: {}): Promise<BlockDatesModel[] | ErrorInfo> {
  return api
    .getBlockDates(query)
    .then((response: ApiResponse<ResponseModel<BlockDatesModel[]>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data?.data) {
          return data?.data?.map((r) => ({
            id: r.id,
            description: r.description,
            fromDate: r.fromDate,
            toDate: r.toDate,
            unitTypeId: r.unitTypeId,
            roomId: r.roomId,
            roomName: r.roomName,
            isCancelled: r.isCancelled,
            unitName: r.unitName,
            area: r.area,
            propertyName: r.propertyName,
            modifiedByUsername: r.modifiedByUsername,
            createdByUsername: r.createdByUsername,
            createdAt: r.createdAt,
            updatedAt: r.updatedAt
          }));
        } else {
          return errorHelper(0, '', getModuleName(), (api.getBlockDates as any).displayName);
        }
      } else {
        return errorHelper(
          Number(response.status),
          response.data?.errorCode ? String(response.data.errorCode || '') : response.problem,
          getModuleName(),
          (api.getBlockDates as any).displayName
        );
      }
    });
}
